import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";

export const CompanyImage = styled.img`
  margin-top: 48px;
  margin-bottom: 24px;
`;

export const CompanyLogo = styled.img`
  padding: 9px 0;
`;

export const CompanyName = styled.h2`
  margin-left: 8px;
  font-size: 16px;
  @media only screen and (min-width: 38em) {
    margin-left: 24px;
    font-size: 21px;
  }
`;

export const CompanyReferences = styled.div`
  margin: 48px 0;
`;

export const CompanyTitle = styled.div`
  text-align: center;
  font-size: 2rem;
  letter-spacing: 10px;
  margin-bottom: 96px;
`;

export const Container = styled.div`
  background: black;
  background: #111;
  color: white;
  font-size: 16px;
  line-height: 1.5;
  min-height: 1000px;
`;

export const Footer = styled.footer`
  background: black;
  background: #111;
  padding: 0 24px;
  height: 500px;
  color: white;
  line-height: 1.5;
`;

export const H1 = styled.h1`
  font-size: 45px;
  line-height: 48px;
  margin-top: 24px;
  margin-bottom: 48px;
`;

export const H2 = styled.h2`
  font-size: 32px;
  line-height: 48px;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const H3 = styled.h3`
  font-size: 23px;
  line-height: 36px;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const H4 = styled.h4`
  font-size: 19px;
  line-height: 24px;
  margin-top: 24px;
  margin-bottom: 24px;
  font-weight: normal;
`;

export const HeaderFixed = styled.header`
  align-items: center;
  background: #111;
  color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 48px;
  padding: 0 8px;
  position: fixed;
  width: 100%;
  z-index: 1000;
  @media only screen and (min-width: 38em) {
    padding: 0 24px;
  }
  @media handheld, screen and (max-width: 768px) {
    display: none;
  }
`;

export const HeaderHidden = styled.header`
  align-items: center;
  background: #111;
  color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 48px;
  padding: 0 8px;
  width: 100%;
  z-index: 1000;
  @media only screen and (min-width: 38em) {
    padding: 0 24px;
  }
`;

export const HomeLink = styled(Link)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  margin: 0 8px;
`;

export const Img = styled.img`
  width: 100%;
  margin-bottom: 48px;
  image-rendering: crisp-edges;
  image-rendering: pixelated;
  }
  &.blur-up {
    filter: blur(5px);
    transition: filter 0ms;
  }

  &.blur-up.lazyloaded {
    filter: blur(0);
  }
`;

export const ImgScaled = styled.img`
  @media only screen
  and (orientation: landscape) {
    object-fit: contain;
    font-family: 'object-fit: contain';
    height: 92vh;
  }
  width: 100%;
  margin-bottom: 96px;
  image-rendering: crisp-edges;
  }
  &.blur-up {
    filter: blur(5px);
    transition: filter 0ms;
  }

  &.blur-up.lazyloaded {
    filter: blur(0);
  }

`;

export const LinkStyled = styled(NavLink)``;

export const Menu = styled.nav`
  display: flex;
  flex: 1 1 auto;
  text-align: right;
  flex-flow: row wrap;
  justify-content: flex-end;
  line-height: 1.5;
`;

export const MenuItem = styled(NavLink)`
  margin: 0 8px;
  flex: 0 0 auto;
  &.active {
    border-bottom: 1px solid white;
  }
`;

export const NoWrap = styled.span`
  hyphens: none;
  white-space: nowrap;
`;

export const P = styled.p`
  margin-top: 0px;
  margin-bottom: 24px;
`;

export const Page = styled.div`
  display: block;
  max-width: 1200px;
  margin: 0 auto 48px;
  padding: 24px;
`;

export const SiteInfo = styled.div`
  text-align: left;
  display: flex;
  flex-flow: column;
`;

export const SitemapItem = styled(Link)`
  display: block;
`;

export const TextBlock = styled.div`
  margin-top: 0px;
  margin-bottom: 48px;
  text-align: justify;
`;

export const theme = {
  // breakpoints: ["38em", "60em"]
};

export const TitleBlock = styled.h2`
  font-size: 32px;
  line-height: 48px;
  margin-top: 24px;
  margin-bottom: 24px;
  text-align: center;
`;

export const TitleThumb = styled.h2`
  font-size: 24px;
  line-height: 48px;
  margin-top: 24px;
  margin-bottom: 24px;
  text-align: center;
`;

export const Ul = styled.ul`
  list-style-type: square;
  padding: 0 0 0 16px;
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/styled-components/index.js